module.exports = __webpack_public_path__ + "media/images/search-filter-80e8d4829d12f33a2a98531527a494f7.svg";